import { Injectable } from '@angular/core';
import moment from 'moment'
@Injectable()

export class StartEndService{

    validStartEnd(startdate: any, enddate: any){
        if (moment(startdate).format() > moment(enddate).format()){
            return false;
        }else{
            return true;
        }
    }
}



// WEBPACK FOOTER //
// ./src/providers/start-end-date.service/start-end-date.service.ts